export default __webpack_public_path__ + "f67a9989ca29599fb5049de81a388d5f.svg";